function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "happy face icon");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Version-2.1---User-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wizard---Milestone-2",
  transform: "translate(-449.000000, -621.000000)",
  stroke: "#00AEFF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(197.000000, 622.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "happy-face-icon",
  transform: "translate(253.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.2142857,71.4285714 C98.2142857,91.1530268 82.2244554,107.142857 62.5,107.142857 C42.7755446,107.142857 26.7857143,91.1530268 26.7857143,71.4285714 L98.2142857,71.4285714 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6428571,53.5714286 C44.6428571,48.6403147 40.6453996,44.6428571 35.7142857,44.6428571 C30.7831719,44.6428571 26.7857143,48.6403147 26.7857143,53.5714286",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.2142857,53.5714286 C98.2142857,48.6403147 94.2168281,44.6428571 89.2857143,44.6428571 C84.3546004,44.6428571 80.3571429,48.6403147 80.3571429,53.5714286",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 62.5,
  cy: 62.5,
  r: 62.5
})))));

var SvgMileStoneIcon = function SvgMileStoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "127px",
    height: "127px",
    viewBox: "0 0 127 127",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMileStoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mileStoneIcon.c7ec3969.svg";
export { ForwardRef as ReactComponent };